import { withSpacing } from '../../../util/spacing.js';
import styled, { keyframes, css } from 'styled-components';

var radiusToPercentage = 62.8318;
var rotate = /*#__PURE__*/keyframes({
  '0%': {
    transform: 'rotate(-90deg)'
  },
  '100%': {
    transform: 'rotate(630deg)'
  }
});
var dash = /*#__PURE__*/keyframes({
  '0%': {
    strokeDashoffset: 0.75 * radiusToPercentage
  },
  '50%': {
    strokeDashoffset: 0.25 * radiusToPercentage
  },
  '100%': {
    strokeDashoffset: 0.75 * radiusToPercentage
  }
});
var RadialLoaderTrackStyled = /*#__PURE__*/styled.circle.withConfig({
  displayName: "Radialstyled__RadialLoaderTrackStyled",
  componentId: "sc-h77czv-0"
})(function (props) {
  return {
    strokeDasharray: radiusToPercentage,
    strokeDashoffset: (props.$percentage ? 1 - props.$percentage / 100 : 0.75) * radiusToPercentage,
    strokeMiterlimit: 0,
    strokeLinecap: 'round'
  };
}, function (props) {
  return props.$percentage ? undefined : css(["animation:", " 2s ease-in infinite;"], dash);
});
var RadialLoaderStyled = /*#__PURE__*/styled(withSpacing('svg')).withConfig({
  displayName: "Radialstyled__RadialLoaderStyled",
  componentId: "sc-h77czv-1"
})(function () {
  return {
    transform: 'rotate(-90deg)',
    transformOrigin: 'center center',
    shapeRendering: 'geometricPrecision'
  };
}, function (props) {
  return props.$percentage ? undefined : css(["animation:", " 2s linear infinite;"], rotate);
});

export { RadialLoaderStyled, RadialLoaderTrackStyled };
//# sourceMappingURL=Radial.styled.js.map
